export default {
    phone : "+351961075935",
    email : "paniconfianca@gmail.com",
    facebook : "https://www.facebook.com/Paniconfianca"
}